import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { StateTopicEnum } from './enums';
import { publish } from './hooks';
import { goFetch } from './utilities';
import { contentTypes } from './utilities/goFetch';
import config from './_config/global';
import { securityService } from './_global/services';
declare global {
  interface Window {
    analytics: any;
  }
}

goFetch.configureDefaults({
  defaultResponseParser: async (r: Response) => {
    if (r.status === 401) {
      await securityService.logout();
      publish(StateTopicEnum.User401, true);
      return null;
    }
    return await r.json();
  },
  appRoot: config.URL,
  queryParameters: {},
  headers: { 'Content-Type': contentTypes.json }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') ?? document.getElementsByTagName('body')[0]
);

function decalreAnalytics() {
  var analytics = (window.analytics = window.analytics || []);
  if (!analytics.initialize)
    if (analytics.invoked)
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.');
    else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware'
      ];
      analytics.factory = function (e: any) {
        return function () {
          var t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };
      for (var e = 0; e < analytics.methods.length; e++) {
        var key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }
      analytics.load = function (key: any, e: any) {
        var t = document.createElement('script');
        t.type = 'text/javascript';
        t.async = !0;
        t.src =
          'https://cdn.segment.com/analytics.js/v1/' +
          key +
          '/analytics.min.js';
        var n = document.getElementsByTagName('script')[0];
        n.parentNode!.insertBefore(t, n);
        analytics._loadOptions = e;
      };
      analytics._writeKey = config.segmentKey;
      analytics.SNIPPET_VERSION = '4.15.3';
      analytics.load(config.segmentKey);
      analytics.page();
    }
}

decalreAnalytics();
root.render(<App />);
